import Swiper from 'swiper/js/swiper.min';

export default function () {
    new Swiper('.swiper-container', {
        effect: 'fade',
        loop: true,
        autoplay: true,
        speed: 1000
    });

    new Swiper('.swiper-header-overlay', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        autoplay: {
            delay: 3000
        },
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: false
    });

    new Swiper('.swiper-header-background', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        autoplay: {
            delay: 3000
        },
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: false
    });

    var galleryThumbs = new Swiper('.c-shoppart__images--small', {
        direction: 'vertical',
        spaceBetween: 0,
        loopedSlides: 3,
        slidesPerView: 3,
        watchSlidesVisibility: true,
        watchSlidesProgress: true
    });

    new Swiper('.homepage-carousel-one', {
        effect: 'fade',
        slidesPerView: 1,
        loop: true,
        allowTouchMove: false,
        navigation: {
            nextEl: '.swiper-carousel-button-next',
            prevEl: '.swiper-carousel-button-prev'
        }
    });

    var homepageCarouselTwo = new Swiper('.homepage-carousel-two', {
        initialSlide: 1,
        slidesPerView: 1,
        allowTouchMove: false,
        spaceBetween: 40,
        loop: true,
        loopedSlides: 2
    });

    const nextButton = document.querySelector('.swiper-carousel-button-next');
    const prevButton = document.querySelector('.swiper-carousel-button-prev');

    if (nextButton) {
        nextButton.addEventListener('click', function () {
            homepageCarouselTwo.slideNext();
        });
    }

    if (prevButton) {
        prevButton.addEventListener('click', function () {
            homepageCarouselTwo.slidePrev();
        });
    }
}
